import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import utilities from './utilities/utility';
import fb from './firebaseConfig.js';
import { firestorePlugin } from 'vuefire';
import './registerServiceWorker';
import { VueMasonryPlugin } from "vue-masonry";

Vue.use(VueMasonryPlugin);
Vue.use(require('vue-moment'));
Vue.use(firestorePlugin);
Vue.mixin(utilities.mixin());


Vue.config.productionTip = false;

let app;
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App),
      created(){
        // this.$store.dispatch('fetchOrders');
      }
    }).$mount('#app')
  }
})
